import React, { useState } from 'react'
import { Desktop, Mobile } from '../../../components/media'
import Tabs from '../../../components/tabs'
import InfoCard from '../../../components/info-card'

const desktopTabs = ['No Middlemen', 'Auctions', 'Safe & Secure']
const mobileTabs = ['No Middlemen', 'Auctions', 'Secure']

const VehicleMarketplace = () => {
  const [activeTabIndex, setActiveTabIndex] = useState(0)

  return (
    <>
      <h2>Vehicle Marketplace</h2>
      <div className='tabsWrapper'>
        <Desktop>
          <Tabs
            activeIndex={activeTabIndex}
            onChange={(newIndex) => setActiveTabIndex(newIndex)}
            tabs={desktopTabs}
          />
        </Desktop>

        <Mobile>
          <Tabs
            activeIndex={activeTabIndex}
            onChange={(newIndex) => setActiveTabIndex(newIndex)}
            tabs={mobileTabs}
          />
        </Mobile>
      </div>

      <div className='tabContent'>
        {activeTabIndex === 0 && (
          <InfoCard isSlide handleClick={() => setActiveTabIndex(activeTabIndex + 1)}>
            <div className='imageContainer flex justifyCenter'>
              <img
                className='withNoPadding'
                src='/images/man-signing-paperwork.jpg'
                alt='man signing paperwork'
                width='1020'
                height='620'
              />
            </div>
            <aside>
              <h3>No Middlemen</h3>
              <p>
                {`People use Dealerships and Car buying services so that they can have peace of mind
                when buying or selling their vehicle. But those middlemen need to bake in profits
                that ultimately costs YOU money. We created privauto to act as that middle
                layer of security to give private buyers and sellers a safe harbor to conduct their
                sale. We validate the seller's inspection, guarantee all funds, offer a 7 day no
                hassle return on all private party sales and will act as the intermediary to make
                the transaction smooth. All this for a $${process.env.NEXT_PUBLIC_BUY_FEE} service fee!`}
              </p>
            </aside>
          </InfoCard>
        )}
        {activeTabIndex === 1 && (
          <InfoCard isSlide handleClick={() => setActiveTabIndex(activeTabIndex + 1)}>
            <div className='imageContainer flex justifyCenter'>
              <img src='/images/auction.png' alt='auction' width='880' height='510' />
            </div>
            <aside>
              <h3>Auction</h3>
              <p>
                You are in the drivrz seat when deciding how much you want to pay for a vehicle.
                Your days of haggling and high pressure sales are over! Take your time, browse the
                site and figure out just how much you are willing to spend on your next vehicle. We
                even include some typical payments based on the current top bid of the auction, so
                you can easily stay within your budget!
              </p>
            </aside>
          </InfoCard>
        )}
        {activeTabIndex === 2 && (
          <InfoCard isSlide handleClick={() => setActiveTabIndex(0)}>
            <div className='imageContainer flex justifyCenter'>
              <img
                className='withNoPadding'
                src='/images/safe-and-secure.jpg'
                alt='handshake'
                width='1020'
                height='620'
              />
            </div>
            <aside>
              <h3>Safe and Secure</h3>
              <p>
                At privauto we make sure that every seller and every buyer has their identity
                verified with the platform before being allowed to participate. privauto will
                never expose your identity, which allows people to be verified AND anonymous.
                privauto will also act as an intermediary in the vehicle transaction, so that
                payment and title transfer is seamless and fraud proof.
              </p>
            </aside>
          </InfoCard>
        )}
      </div>

      <style jsx>{`
        h2 {
          text-align: center;
          line-height: 7.1rem;
          font-size: 5.4rem;
        }

        .intro {
          max-width: 123rem;
          margin: 2.2rem auto 2.4rem;
          text-align: center;
          line-height: 3.6rem;
          font-size: 2.4rem;
        }

        .tabsWrapper {
          max-width: 73.6rem;
          width: 100%;
          margin: 2rem auto 5.2rem;
        }

        .tabContent {
          margin: 5.2rem auto 0;
          max-width: 153.2rem;

          .imageContainer {
            max-width: 101.7rem;
            width: 100%;
            min-height: 62.3rem;
            background: linear-gradient(180deg, #fff, rgba(255, 255, 255, 0));

            img {
              width: 100%;
              height: 100%;
            }

            img {
              &:not(.withNoPadding) {
                padding: 5rem 7rem;
                object-fit: contain;
              }
            }

            img {
              &.withNoPadding {
                object-fit: cover;
              }
            }
          }

          aside {
            max-width: 51.3rem;
            padding: 7rem 7.5rem 7rem 7.3rem;
          }

          h3 {
            margin: 0 0 1.4rem;
            line-height: 4.3rem;
            font-size: 3.2rem;
          }

          p {
            line-height: 3rem;
            font-size: 2.2rem;
          }
        }

        @media (max-width: 1024px) {
          h2 {
            line-height: 2.6rem;
            font-size: 2rem;
          }

          .intro {
            max-width: 100%;
            margin: 1rem auto 1.5rem;
            line-height: 1.8rem;
            font-size: 1.4rem;
          }

          .tabsWrapper {
            margin: 1.3rem auto 1.9rem;
            padding: 0 1.2rem;
          }

          .tabContent {
            margin: 1.9rem 0 0;

            .imageContainer {
              min-height: unset;

              img {
                &:not(.withNoPadding) {
                  padding: 1.6rem 4.3rem;
                }
              }
            }

            aside {
              max-width: 100%;
              padding: 2.6rem 2.8rem 6.7rem;
            }

            h3 {
              margin: 0 0 1.1rem;
              line-height: 2rem;
              font-size: 1.4rem;
            }

            p {
              line-height: unset;
              font-size: 1.4rem;
            }
          }
        }
      `}</style>
    </>
  )
}

export default VehicleMarketplace
